export default "__VITE_ASSET__CubJ6wi4__"